import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'simNaoPipe',
    pure: true
  })
  
export class SimNaoPipe implements PipeTransform {

    transform(value: boolean, args?: any): any {

        return (value == true ? 'SIM' : 'NÃO');
    }

}
